const ArrowDown = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        d="M4.39727 5.64375L0.153516 1.4C0.0514323 1.29792 0.000390623 1.17396 0.000390623 1.02813C0.000390623 0.882292 0.0514323 0.758333 0.153516 0.65625L0.634766 0.175C0.736849 0.0729168 0.860807 0.0218751 1.00664 0.0218751C1.15247 0.00729179 1.27643 0.0510418 1.37852 0.153125L4.76914 3.54375L8.15977 0.153125C8.26185 0.0510418 8.38581 0.00729179 8.53164 0.0218751C8.67747 0.0218751 8.80143 0.0729168 8.90352 0.175L9.38477 0.65625C9.48685 0.758333 9.53789 0.882292 9.53789 1.02813C9.53789 1.17396 9.48685 1.29792 9.38477 1.4L5.14102 5.64375C5.03893 5.76042 4.91497 5.81875 4.76914 5.81875C4.62331 5.81875 4.49935 5.76042 4.39727 5.64375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowDown;
